<template>
    <div class="amazon-liveness-capture">
        <div>
            <button type="button" @click="fetchSessionId()" class="btn btn-outline-primary"> <span
                    class="bi me-2 bi-camera"></span> Take Picture </button>
        </div>
        <div v-if="popupModalConfirm" class="popup-liveness-check">
            <div class="popup-content position-relative ">
                <button type="button" @click="initializeAll()" class="btn-close"></button>
                <div class="row justify-content-center align-items-center row h-100">
                    <div class="col-sm-6 col-lg-4">
                        <div v-if="!isLoading">
                            <div v-if="errorMessage" class="alert alert-danger">
                                <h5>Something went wrong</h5>
                                <p>{{ errorMessage }}</p>
                                <div class="d-grid">
                                    <button @click="fetchSessionId()" type="button" class="btn btn-primary">Try
                                        Again</button>
                                </div>
                            </div>
                            <div v-else>
                                <h3>Hey, <span class="text-capitalize">{{ username || 'Guest' }}</span></h3>
                                <p>We need to perform an identity check to ensure that you own the data that you have
                                    submitted to our platform. This will only take a moment.</p>
                                <button @click="startLivenessTest()" type="button" class="btn btn-primary">Perform
                                    liveness check</button>
                            </div>
                        </div>
                        <CommonSpinner v-else />
                    </div>
                </div>
            </div>
        </div>

        <b-modal size="md" id="popupFrameModal" body-class="pt-0 px-2 pb-3 rounded-0" v-model="popupModalFrame.visible"
            @hide="closeLivenessFrame()" title="Perform Liveness test" hide-footer>
            <div v-if="isiFrameLoading" class="pt-5">
                <CommonSpinner />
            </div>
            <iframe :src="popupModalFrame.url" @load="() => isiFrameLoading = false"
                allow="camera; microphone; clipboard-read; clipboard-write" style="width: 100%; height: 600px;"
                frameborder="0"></iframe>
        </b-modal>
    </div>
</template>
<script>

export default {
    props: {
        username: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            sessionId: null,
            errorMessage: "",
            popupModalConfirm: false,
            isLoading: false,
            isiFrameLoading: false,
            livenessTestHost: "https://liveness.akwaibom.tech",
            popupModalFrame: {
                visible: false,
                url: ""
            }
        };
    },
    methods: {
        fetchSessionId() {
            this.popupModalConfirm = true
            this.isLoading = true
            this.errorMessage = null
            this.$http.post(this.absoluteApiUrl("/liveness/create"))
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.sessionId = response.data.data.session_id
                    } else {
                        this.errorMessage = response.data.message;
                    }
                })
        },
        startLivenessTest() {
            if (!this.sessionId) {
                this.alertError("No session ID available. Close and try again");
                return;
            }

            const token = this.$store.getters.authToken;
            if (!token) {
                this.alertError("Authentication token is missing or expired.");
                return;
            }

            const payload = {
                endpoint: btoa(unescape(encodeURIComponent(this.absoluteApiUrl()))),
                session_id: this.sessionId,
                authorization: `Bearer ${token}`
            }

            this.popupModalFrame.url = `${this.livenessTestHost}?${new URLSearchParams(payload).toString()}`
            this.popupModalFrame.visible = true
            this.isiFrameLoading = true
            this.setWindowListener()
        },
        setWindowListener() {
            window.addEventListener('message', (event) => {
                if (event.origin === this.livenessTestHost) {
                    if (event.data.is_live && event.data.image) {
                        this.$emit('livenessSuccess', event.data.image)
                        this.initializeAll()
                    } else {
                        this.closeLivenessFrame(event.data.message || '')
                    }
                }
            });
        },
        closeLivenessFrame(message = '') {
            this.popupModalFrame = { visible: false, url: "" }
            this.errorMessage = message || "Liveness Test Failed"
        },
        initializeAll() {
            this.sessionId = null;
            this.errorMessage = "";
            this.popupModalConfirm = false;
            this.isLoading = false
            this.closeLivenessFrame()
        }
    },
};
</script>

<style scoped>
.amazon-liveness-capture .popup-liveness-check {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    /* background-color: rgba(0, 0, 0, 0.5); */
    background-color: rgb(255, 255, 255);
    z-index: 1050;
    overflow: hidden;
}

.amazon-liveness-capture #pdfFrameModal {
    z-index: 1060;
}

.amazon-liveness-capture .popup-liveness-check .popup-content {
    background-color: white;
    border-radius: 0;
    padding: 20px;
}

.amazon-liveness-capture .popup-liveness-check .btn-close {
    position: absolute;
    top: 15px;
    left: 15px;
    background-color: black;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAahJREFUSEvdlTsvRFEUhb9NNF6NRqKkEZ3Qa8Q/oPCIRCRToFL6BSIa4pEQtUYjkeh0EjQiMYXEHyAKEY8I29mTe5PjzjlnFKbgJlPNuWvtve5a6wh1fqTO+PxDAlWdBsbd7wbYAa5E5D0mpaoOATPAE3ACHIrIc36+SiJVPQBGAAUu3YuLwEWIJANfA7qBT+AYKInIXYpgHbAtWgCb/DxE4oH3Ao0Z4CawJCIPKYJ+wKYaBJpCJBFwk6dk0oqIbVN5QhIZ6ACwEiFpBVYBf3IDnwfKIvLhf6+gTVU1RlJ223UAnZ4sUfDgBjl7hMSmy/W2o0nwJIH96ZFsAX0FcPv4Zs/roiw1JfIPqOowsAd0FbJgcs0CZ6mcJKsi4pacJ2rhH20QATdZzEU9MQsXEx9zkcXfslC04oKzaDuwnMpJcoNEiCo+Bxpq5ORbrYSCtg1MuCmbs0mqrJjIiZVjzarYAKayLor6PEKyD8yJyH2qKsact0ezut51ZLcxn3skk8CLa+FT4KhWXZs0eZM++sUVuhMykrasrt+AVxGxqg+X3W/f0X//Tv4CDeG/GVgkzHsAAAAASUVORK5CYII=")
}

@media(min-width: 786px) {
    .amazon-liveness-capture .popup-liveness-check .popup-content {
        margin: 0px auto;
        width: 100%;
        height: 100vh;
        border-radius: 5px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    }
}

@media(max-width: 786px) {
    .amazon-liveness-capture .popup-liveness-check .popup-content {
        width: 100%;
        height: 100%;
    }
}
</style>
